"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Modal = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/layout/Modal"));
var _devicesize = require("@oberoninternal/travelbase-ds/context/devicesize");
var _grid = require("@rebass/grid");
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ActivityPlanner = _interopRequireDefault(require("./ActivityPlanner"));
var _ActivityTickets = _interopRequireDefault(require("./ActivityTickets"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
const ActivityPlannerModal = ({
  activity,
  slug,
  selectedDay,
  setSelectedDay,
  setTimeslot,
  open,
  onClose,
  setTicket,
  ticket,
  timeslot,
  setEdit,
  activityTickets,
  openActivityTickets,
  openActivityPlanner,
  onActvityBack,
  onActivityPlanner,
  onModalClose
}) => {
  const modalRef = (0, _react.useRef)(null);
  const scrollOptions = {
    scrollRef: modalRef
  };
  const deviceSize = (0, _devicesize.useDeviceSize)();
  return __jsx(StyledModal, {
    contentRef: modalRef,
    open: open,
    onClose: onClose,
    variant: "full"
  }, __jsx(Content, null, deviceSize !== 'mobile' && __jsx(_react.default.Fragment, null, !activityTickets && __jsx(_ActivityPlanner.default, {
    activity: activity,
    onSelectScrollOpts: scrollOptions,
    slug: slug,
    selectedDay: selectedDay,
    setSelectedDay: setSelectedDay,
    setTimeslot: setTimeslot,
    isOpenModal: open
  }), activityTickets && __jsx(_ActivityTickets.default, {
    activity: activity,
    setTicket: setTicket,
    onClose: onClose,
    open: open,
    timeslot: timeslot,
    ticket: ticket,
    setEdit: setEdit
  })), deviceSize === 'mobile' && __jsx(_ActivityPlanner.default, {
    activity: activity,
    onSelectScrollOpts: scrollOptions,
    slug: slug,
    selectedDay: selectedDay,
    setSelectedDay: setSelectedDay,
    setTimeslot: setTimeslot,
    isOpenModal: open,
    setTicket: setTicket,
    activityTimeslot: timeslot,
    ticket: ticket,
    openActivityTickets: openActivityTickets,
    onBack: onActvityBack,
    openActivityPlanner: openActivityPlanner,
    onActivityPlanner: onActivityPlanner,
    onModalClose: onModalClose
  })));
};
var _default = exports.default = ActivityPlannerModal;
const Content = (0, _styledComponents.default)(_grid.Box).withConfig({
  displayName: "ActivityPlannerModal__Content",
  componentId: "bx4psd-0"
})(["overflow:hidden;@media screen and (min-width:", "){padding:4rem 2.4rem 10rem 2.4rem;overflow:visible;}width:100%;max-width:140.8rem;margin:auto;@media screen and (max-width:", "px){height:100%;}"], ({
  theme
}) => theme.mediaQueries.s, ({
  theme
}) => theme.mediaQueriesValues.s - 1);
const StyledModal = (0, _styledComponents.default)(_Modal.default).withConfig({
  displayName: "ActivityPlannerModal__StyledModal",
  componentId: "bx4psd-1"
})(["&& > [data-reach-dialog-overlay]{overflow:unset;}&& > [data-reach-dialog-content]{padding:0;}@media screen and (max-width:", "px){padding:0;}"], ({
  theme
}) => theme.mediaQueriesValues.s - 1);